import script from "./BonusCampaignGoalReminderWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./BonusCampaignGoalReminderWidget.vue?vue&type=script&setup=true&lang=js"

import "./BonusCampaignGoalReminderWidget.vue?vue&type=style&index=0&id=6f89bb35&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f89bb35"]])

export default __exports__